import { BaseTabFormData } from '@/modules/common/components/templates/feature-details/types/types';
import { CustomAttributesFormData } from '@/modules/common/types/custom-attribute';
import { RateSource } from '@/modules/common/types/rate-source';
import { ProjectBillingModel, ProjectStatus } from '@/modules/projects/types/project';
import { ProjectIntegration } from '@/modules/projects/types/project-integration';
import { ProjectTeamMember } from '@/modules/projects/types/project-team-member';

export enum ProjectTab {
  Info = 'info',
  Billing = 'billing',
  Integrations = 'integrations',
  Changes = 'changes',
}

export interface ProjectBillingFormData {
  billingModel: ProjectBillingModel;
  currency: string;
  rateSource: RateSource;
  flatRate?: number;
  projectBudget?: number;
  selectedTeamMembers?: ProjectTeamMember[];
  cachedTeamMembers?: ProjectTeamMember[];
  paymentDetailsId?: number | null;
}

export interface ProjectFormData extends BaseTabFormData {
  // Info fields
  name: string;
  color: string | null;
  logo?: File;
  status: ProjectStatus;
  probability?: number;
  industryIds: string[];
  clientId?: string;
  /**
   * Name of a client that the user chose to create inline from the client selector.
   * When set (and clientId is empty), the project save flow will create this client first,
   * then use the returned id as clientId.
   */
  pendingClientName?: string;
  managerIds?: string[];
  startDate?: Date;
  endDate?: Date;
  description: string;
  customAttributes: CustomAttributesFormData;

  // Billing fields
  billingModel?: ProjectBillingModel;
  currency?: string;
  rateSource?: RateSource;
  flatRate?: number;
  projectBudget?: number;
  selectedTeamMembers?: ProjectTeamMember[];
  cachedTeamMembers?: ProjectTeamMember[];
  defaultRateSource?: RateSource;
  paymentDetailsId?: number | null;

  // Integration fields - full integration objects with project mappings
  integrations?: ProjectIntegration[];

  // Effective date fields - for conflict resolution and change tracking
  effectiveStartDate?: string | Date; // Can be YYYY-MM-DD string or Date object
  effectiveEndDate?: string | Date | null; // Can be YYYY-MM-DD string, Date object, or null for infinite
}

export interface BillingModelOption {
  value: ProjectBillingModel;
  label: string;
  isItemDisabled?: boolean;
  /** Tooltip shown on hover, typically explaining why the option is disabled */
  tooltip?: string;
}

export interface RateSourceOption {
  value: RateSource;
  label: string;
}

export * from './dto/project-status.dto';
export * from './dto/request/find-short-projects-request';
export * from './dto/response/short-project-response';
export * from './patch-project-change-params';
export * from './project';
export * from './project-change-deletion';
export * from './project-integration';
export * from './project-team-member';
